import {Accordion, List,  Text, Title} from '@mantine/core';
import { DateTime } from 'luxon';
import { BigVideo, JWHostedPlayer } from '../components/Video';
import { WPNggBlock, WPVideoBlock, WPBlock, JWVideoBlock, WPImageBlock } from './definitions';
import { MyCarousel } from '../components/MyCarousel';
import { AspectBox } from '../components/AspectBox';

const imgRegEx2 = new RegExp(/((.|\r|\n)*)<img .*src\s*=\s*("|')(http(?:s?):\/\/(?:rawumberstudios|rawumber-test)\.com\/wp-content\/uploads\/(.*?))"(.*?)>((.|\r|\n)*)/);
type IndexContext =
{
    index : number;
}

function getParams(fullTag: string)
{
    let i = fullTag.indexOf("{");

    if (!i)
    {
        return null;
    }

    let params = fullTag.substring(i);

    return JSON.parse(params);

}
function parseDangerousHTML(html? : string)
{

    if (!html)
    {
        return {__html:''};
    }

    //let h = html.replaceAll(aRegEx, `<a href='$3' onclick='parseWPClick()'>$4</a>`);


    return  {__html:html};

}
function blockToJsx(block : WPBlock, ctx : IndexContext)
{    
    let innerBlocks = <></>
    let useInnerBlocks = false;

    let openingHtml="";
    let closingHtml="";

    ctx.index ++;

    if (block.innerBlocks!=null && block.innerBlocks.length!=0)
    {
        //if it has sub blocks then we need to take the first and last item from innerContents
        //and use that
        innerBlocks = translateWPBlocksToJSX(block.innerBlocks, ctx);
        useInnerBlocks = true;
    }

    let jsx=<></>
    //let innerBlockClass="";

    let attrs = (block.attrs as any);
    
    switch (block.blockName)
    {
        case "core/image":

            let ib = block as WPImageBlock;
            let w = 1024;

            let doNotForceResize=false;
            
            if (ib.extraData)
            {
                switch (ib.extraData.sizeSlug)
                {
                    case "large":
                        w= 1024;
                        doNotForceResize=true;
                        break;
                    case "medium":
                        w=300;
                        break;
                    case "thumbnail":
                        w=150;
                        break;
                    case "full":
                        doNotForceResize=true;
                        break;
                }
            }

            let iHTML = block.innerHTML;
            let r4 = imgRegEx2.exec(iHTML);

            if (attrs.width)
            {

                console.log(attrs.width);

                if (typeof attrs.width == 'string')
                {
                    let ws: string = attrs.width;
                    if (ws.endsWith('px'))
                    {
                        w=Number(ws.substring(0, ws.length-2));
                    }
                    else
                    {
                        w=Number(ws);
                    }
                }
                else
                {
                    w=attrs.width as number;
                }

                doNotForceResize=true;
            }

            if (r4)
            {
                let slug = encodeURIComponent(r4[5]);
                iHTML = iHTML.replace(imgRegEx2, `$1
                <div class='rus-aspect-ratio-box' style='padding-top:${100 * ib.extraData.height / ib.extraData.width}%'>               
                <div class='rus-aspect-ratio-box-inside'> 
                <img class='wp-image'  src="/n/api/wpimage?slug=${slug}&w=${w}&x=1">
                </div>
                </div>
                $7`);
             
            }



            //want to set max height to 400px, but need to set width to stop aspect ratio distortion

            let h = w * ib.extraData.height / ib.extraData.width;

            if (h>400 && !doNotForceResize)
            {
                w = ib.extraData.width * 400 / ib.extraData.height;
            }

            return <div key={ctx.index} style={{maxWidth:w, flex: `${ib.extraData.width/ib.extraData.height}` }} className='wp-image-container' dangerouslySetInnerHTML={parseDangerousHTML(iHTML)}></div>

        case "core/media-text":

            let percentageWidth = attrs.mediaWidth;
            let rightAlign = attrs.mediaPosition=="right";
            let va = attrs.verticalAlignment;

            return <div key={ctx.index} className={rightAlign?"wp-media-text-flipped":"wp-media-text"} style={{alignItems:(va??'flex-start') }}>
                <div key='block-1' style={{flexBasis:`${percentageWidth}%`}} dangerouslySetInnerHTML={{__html:block.innerHTML??''}}></div>
                <div key='block-2' style={{flexBasis:`${100-percentageWidth}%`}}>
                {innerBlocks}
                </div>
            </div>

        case "generateblocks/button":

            return <div key={ctx.index} className='wp-button-container'><div className='wp-button' dangerouslySetInnerHTML={{__html:block.innerHTML??''}}></div></div>

        case "core/columns":

            return <div key ={ctx.index} className='wp-columns'>{innerBlocks}</div>
        case "core/column":

            if (useInnerBlocks)
            {
                return <div key={ctx.index} className='wp-column'>{innerBlocks}</div>                
            }
            else
            {
                return <div key={ctx.index} className='wp-column' dangerouslySetInnerHTML={{__html:block.innerHTML??''}}></div>                
            }
        case "aab/group-accordion":
            return <Accordion key={ctx.index}>{innerBlocks}</Accordion>
        case "aab/accordion-item":
  
            return <Accordion.Item value={'accordion-' + ctx.index} key={ctx.index}>
                <Accordion.Control>
                <span dangerouslySetInnerHTML={{__html:block.parsedHTML??''}}></span>
                    </Accordion.Control>
                    <Accordion.Panel>
                    {innerBlocks}
                    </Accordion.Panel></Accordion.Item>
        case "generateblocks/headline":

            return <Title key={ctx.index} order={block.extraData.level} align={(block.attrs as any).alignment??'left'} mt='md'><span dangerouslySetInnerHTML={{__html:block.parsedHTML??''}}></span></Title>            
        case "core/heading":

            return <Title key={ctx.index} order={block.extraData.level} align={(block.attrs as any).textAlign??'left'} mt='md'><span dangerouslySetInnerHTML={{__html:block.parsedHTML??''}}></span></Title>
        case "core/gallery":

            return  <div key={ctx.index}  className="wp-gallery">{innerBlocks}</div>
            //innerBlockClass="wp-gallery";
        case "core/list":

            if (useInnerBlocks)
            {
                return  <List key={ctx.index}  mb='sm'>{innerBlocks}</List>
            }
            else
            {
                return <div key={ctx.index}  dangerouslySetInnerHTML={parseDangerousHTML(block.innerHTML)}></div>
            }
        case "core/list-item":

            return <List.Item key={ctx.index} ><span dangerouslySetInnerHTML={parseDangerousHTML(block.parsedHTML)}></span></List.Item>
        case "core/paragraph":

            return <Text align={attrs.align??'left'} key={ctx.index} className={attrs.className??''} mt='sm' mb='sm'><span dangerouslySetInnerHTML={parseDangerousHTML(block.parsedHTML)}></span></Text>
        case "core/quote":

            if (block.parsedHTML)
            {              
                if (useInnerBlocks)
                 { 
                jsx=<blockquote className="wp-blockquote" key={ctx.index} >{innerBlocks}<cite dangerouslySetInnerHTML={parseDangerousHTML(block.parsedHTML)}></cite></blockquote>
                 }
                 else
                 {
                    jsx=<blockquote className="wp-blockquote" key={ctx.index} ><span dangerouslySetInnerHTML={parseDangerousHTML(block.innerHTML)}></span></blockquote>

                 }
            }
            else
            {
                jsx=<blockquote className="wp-blockquote" key={ctx.index} >{innerBlocks}</blockquote>
            }
            return jsx;

        case "generateblocks/grid":

            return <div key={ctx.index} className={'wp-columns ' + (attrs.className?(" " + attrs.className):"")}>{innerBlocks}</div> 
        case "core/shortcode":
        case "imagely/nextgen-gallery":
        case "core/html":
    
            switch (block?.extraData?.shortcode)
            {
                case 'ngg':
                    let images = (block as WPNggBlock).extraData.imageData;

                    let slides: JSX.Element []  = [];

                    if (images.length<=5)
                    {

                    images.forEach(x=>
                        {
                            if (x.filename)
                            {
                                let h =Math.min(400, x.height);
                                let w = h * x.width/x.height;
                            slides.push(
                               
                            <img key={x.id} width={w} height={h} alt='Photo' className='item' src={"/n/api/thumbnails/" + x.id + ".jpg?t=" + x.updatedAt + "&h=" + h}/>

                            );
                            
                            }
                        }
                        );

                        return <div key={ctx.index} className='wp-grid-container'>
                            {slides}
                        </div>
                    }
                    else
                    {

                    
                    images.forEach(x=>
                    {
                        if (x.filename)
                        {
                        slides.push(<MyCarousel.Slide key={x.id}>
                            
                            <div style={{height:'100%', position:'relative'}}>
            <svg xmlns="http://www.w3.org/2000/svg"
            height={x.height}
            width={x.width}
            style={{width:"auto", height:"100%"}}>
              
            </svg>

            <img style={{position:'absolute', left:'0', top:'0', width:'100%', height:'100%'}} src={"/n/api/thumbnails/" + x.id + "?t=" + x.updatedAt + "&h=400"}></img>

            
            </div>
                            </MyCarousel.Slide>);
                        }
                    });

                   // console.log(slides);

                   {/*

                    jsx=<div key={ctx.index}>
                    {slides.length!=0 && <MyCarousel
                        withIndicators
                        height={400}
                        slideGap="md"
                        slideSize="auto"
                        loop
                        align="start"
                        slidesToScroll={1}
                    >
                        {slides}
                
                       
                    </MyCarousel>}
                    </div>*/}

                    jsx=<div key={ctx.index}>
                    {slides.length!=0 && <MyCarousel>
                        {slides}
                    </MyCarousel>}
                    </div>
                    
                    return jsx;
                    }

                case "rus_video":
                    let video = (block as WPVideoBlock).extraData.video;
                    jsx = <BigVideo key={ctx.index} video={video} dateProcessed={DateTime.now().toISO()}/>
                    return jsx;
                case "rus_jw_video":
                    let jw = (block as JWVideoBlock).extraData;
          

                    jsx =  <AspectBox width={16} height={9}  key={ctx.index}><JWHostedPlayer jwId={jw.jwId} autostart={jw.autostart} controls={jw.controls} loop={jw.loop} mute={jw.mute}/></AspectBox>
                    return jsx;
                default:
                    return <div key={ctx.index} dangerouslySetInnerHTML={parseDangerousHTML(block.innerHTML)}></div>
                
            }

            break;
        default:

            if (block.blockName)
            {
            }

            if (useInnerBlocks)
            {
                jsx=<div key={ctx.index} >{innerBlocks}</div>
                return jsx;
            }
            jsx = <div key={ctx.index} dangerouslySetInnerHTML={parseDangerousHTML(block.innerHTML)}></div> 
            return jsx;


    }


    if (useInnerBlocks)
    {
        return <div key={ctx.index} >{innerBlocks}<>{jsx}</></div>
    }
    else
    {
        return jsx
    }

}

export function translateWPBlocksToJSX(sections : WPBlock[], context: IndexContext | null )
{
    let html : JSX.Element [] = [];
    let i = 0;

    const ctx = (!context)? {index:0} : context;

    sections.forEach(x=>
        {
            ctx.index++;
            let s = blockToJsx(x, ctx);
            html.push(s);            
        });

        return <>{html}</>
    
}